define('Maps',[
  'jquery',
  'zipTools',
  'responsive',
  'googlemaps',

  // side effect includes
  'lib/helpers/toJSON', // used by template-map-dealer-info
],
function (
  $,
  zipTools,
  responsive,
  googleMaps
) {
  var __google;

  var Maps = function Maps(args) {
    this.kind = args.kind; // map, imageMap, multiMarkerMap, directionsMap
    this.mapOptions = args.mapOptions;
    this.mapElement = args.mapElement;
    this.markers = args.markers;
    this.dealerData = args.dealerData;
    this.imgWidth = args.imgWidth;
    this.imgHeight = args.imgHeight;
    this.numberedMarkers = args.numberedMarkers;
    this.useFuelStyle = args.useFuelStyle; // BAT25-99
    this.google = __google;
    if (args.$form) {
      this.$form = args.$form;
    }
    this.init();
  };

  Maps.markerPath = 'http://www.buyatoyota.com/assets/img/maps/';

  Maps.prototype = {
    init: function () {
      var self = this;
      switch (self.kind) {
        case 'map':
          self.initMap();
          break;
        case 'static':
          self.initImageMap();
          break;
        case 'multimarker':
          self.initMultimarker();
          break;
        case 'direction':
          self.initDirections();
          break;
        default:
          self.initMap();
      }
    }, // end init

    // Default: Map Mode
    initMap: function () {},

    // Default: Image Map Mode
    initImageMap: function () {
      var self = this,
      getMapUrl = function () {
        if (self.markers) {
          console.debug('Length: ' + self.markers.length);
          var markers = [];
          var reachedMax = false;
          var markersString = "";
          for (var i = 0; i < self.markers.length; i++) {
            if (!reachedMax) {
              if (self.numberedMarkers) {
                  markers.push("&markers=shadow:false|icon:" + Maps.markerPath + "marker-" + (i + 1) + ".png|" + self.markers[i].lat + "," + self.markers[i].lon);
              } else {
                  markers.push("&markers=shadow:false|icon:" + Maps.markerPath + "marker.png|" + self.markers[i].lat + "," + self.markers[i].lon);
              }
              markersString = markers.join('');
              if (markersString.length >= 1900) {
                  markers.pop();
                  markersString = markers.join('');
                  reachedMax = true;
              }
            }
          }
          return encodeURI("//maps.googleapis.com/maps/api/staticmap?size=" + self.imgWidth + "x" + self.imgHeight + "&maptype=roadmap" + markersString + "&key=AIzaSyDs2iYTroHjB8l7zbfHyWUec2cpESSIVK8");
        } else {
          return encodeURI("//maps.googleapis.com/maps/api/staticmap?size=" + self.imgWidth + "x" + self.imgHeight + "&key=AIzaSyDs2iYTroHjB8l7zbfHyWUec2cpESSIVK8");
        }
      };
      self.mapElement.src = getMapUrl();
    },

    // BAT-3486
    showActiveMarker: function (index) {
      var self = this;
      if(self.lastActiveMarker) {
        var defaultIcon = self.lastActiveMarker.defaultIcon;
          var labelPoint = self.lastActiveMarker.labelPoint;
        self.lastActiveMarker .setIcon({'url': defaultIcon, scaledSize: new __google.maps.Size(33, 43), labelOrigin:labelPoint});
        self.lastActiveMarker = null;
      }

      var activeIcon = this.allMapMarkers[index].activeIcon;
      if (activeIcon !== '') { //ONLY OPEN STATIONS HAVE AN ACTIVE ICON.
          var labelPoint = this.allMapMarkers[index].labelPoint;
        this.allMapMarkers[index].setIcon({'url': activeIcon, scaledSize: new __google.maps.Size(33, 43), labelOrigin:labelPoint});
        self.lastActiveMarker = this.allMapMarkers[index];
      }
    },

    selectMarker: function (index, ignoreCenter, ignoreTrigger) {
      var self = this;
      if(ignoreTrigger) {
        self.ignoreTrigger = true;
      }
      __google.maps.event.trigger(this.allMapMarkers[index], 'click');
      if(!ignoreCenter){
        var userCoords = new __google.maps.LatLng( this.allMapMarkers[index].position.lat(), this.allMapMarkers[index].position.lng());
        self.map.setCenter( userCoords );
      }
    },

    // BAT25-139
    displayLocation: function (position) {
      // console.log(' ::: displayLocation :::', position);
      var self = this;
      var userCoords = new __google.maps.LatLng( position.lat, position.lon);

      // CREATE MARKER
      if ( !self.userLocation ) {

        // CUSTOM MAKER IMAGE.
        var image = new __google.maps.MarkerImage(
          '/assets/img/maps/user-location-dot.png',
          null, // size
          null, // origin
          new __google.maps.Point( 8, 8 ), // anchor (move to center of marker)
          new __google.maps.Size( 17, 17 ) // scaled size (required for Retina display icon)
        );

        // NEW MARKER.
        self.userLocation = new __google.maps.Marker({
          flat: true,
          icon: image,
          map: self.map,
          optimized: false,
          position: userCoords,
          title: 'You are here.', //used in css, not actually displayed.
          visible: true
        });
      } else {
        // POSITION AND SHOW MARKER.
        self.userLocation.setPosition( userCoords );
      }
      self.userLocation.setPosition( userCoords );
      // IF WE WANT TO CENTER ON LOCATION.
      self.map.setCenter( userCoords );
    },

    // MultiMarker Mode
    initMultimarker: function () {
      var self = this;
      var i;
      var marker;
      var markerIcon;
      var infowindow = new __google.maps.InfoWindow({});
      var showMapUI = responsive() === 'sm';

      var zoomVar = 9;
      if (self.markers.length < 2) {
        zoomVar = 12;
      }
      // BAT25-99
      if (self.useFuelStyle) { //BAT25-99
        showMapUI = true;
        var fuelStyledMapType = new __google.maps.StyledMapType([
          {
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#f1f1f2"
              }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#f1f1f2"
              }
            ]
          },
          {
            "featureType": "landscape.natural",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#f1f1f2"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#f1f1f2"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#dadada"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#c2cee5"
              }
            ]
          }
        ]);
      }

      self.map = new __google.maps.Map(self.mapElement, {
        zoom: zoomVar,
        center: new __google.maps.LatLng(self.markers[0].lat, self.markers[0].lon),
        mapTypeId: __google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: showMapUI // will be conflict when merging About page FAD
      });

      if (self.useFuelStyle) { // BAT25-99
        self.map.mapTypes.set('styled_map', fuelStyledMapType);
        self.map.setMapTypeId('styled_map');
      }

      // BAT25-99
      __google.maps.event.addListener(self.map, 'click', function () {
        if (infowindow) {
          infowindow.close();
        }
      });

      self.allMapMarkers = [];

      self.infowindow = infowindow;
      // console.info('self: ', self);

      // Center the map around the bounds of the markers
      var latlngbounds = new __google.maps.LatLngBounds();

      for (var i = 0; i < self.markers.length; i++) {
        latlngbounds.extend(new __google.maps.LatLng(self.markers[i].lat, self.markers[i].lon));
      }

      if (self.markers.length > 1) {
        self.map.fitBounds(latlngbounds);
      }
      self.latlngbounds = latlngbounds;
      // BAT-3486: markers now use generic background images and set label dynamcially for FuelStation maps.
      for (i = 0; i < self.markers.length; i++) {
          // var markerName = self.useFuelStyle ? 'marker-blue-' : 'marker-'; //BAT25-99
          var markerName = self.useFuelStyle ? 'marker-blue-bg' : 'marker-'; //BAT-3486
          if(self.useFuelStyle && self.markers[i].closed ) {
            // BAT-3486: CLOSED FuelStations GET GREY MARKER PIN.
            markerName = 'marker-grey-bg'
          }

          // BAT-3486
          var activeIcon = '';
          if(self.useFuelStyle && !self.markers[i].closed ) {
            // BAT-3486: SELECTED OR ACTIVE MARKE PIN:
            activeIcon = '/assets/img/maps/marker-active-bg@2x.png';
          }

          if (self.numberedMarkers) {  //BAT25-99 ONLY NUMBERED MARKERS USED IN MIRAI FUEL STATIONS MAP.
            markerIcon = '/assets/img/maps/' + markerName + (i + 1) + '.png';
            // default to 2X MAKER FOR RETINA
            if (self.useFuelStyle) {
              // BAT-3486: FuelStation MARKERS PINS ARE DYNAMIC, ONLY BG IS USED, NUMBER IS SET BY LABLE.
              markerIcon = '/assets/img/maps/' + markerName + '@2x.png';

            }
          } else {
            markerIcon = '/assets/img/maps/marker.png';
          }
          var image = {
            url:markerIcon
          };
          var closed = false;
          var label = {'text':''};
          // CORRECT THE SIZE FOR THE MARKER.
          if(self.useFuelStyle ){

            var labelPoint =  new __google.maps.Point(15,14);
            image = {
              url:markerIcon,
              labelOrigin: labelPoint
            };
            image.size = new __google.maps.Size(33, 43);
            // for the setting of the scaled size of the retina marker
            image.scaledSize = new __google.maps.Size(33, 43);
            if(self.markers[i].closed ) {
              closed = true;
            }

            var labelstr = (i + 1).toString();
            label = {'text':labelstr, 'color': '#fff', 'fontWeight':'600', 'fontSize': '14px'};

            /*
              BAT-3486 FUEL STATIONS GET SOME SPECIAL TREATMENT AND MARKERS WITH STATIC IMAGE AND DYNAMIC LABELS,
              ALSO SOME OTHER ITEMS FOR SELECTING ACTIVE STATION.
            */
            marker = new __google.maps.Marker({
              position: new __google.maps.LatLng(self.markers[i].lat, self.markers[i].lon),
              map: self.map,
              icon: image,
              // labelClass: 'datalayer-link'
              labelClass: 'aa-link',
              activeIcon:activeIcon,
              defaultIcon:markerIcon,
              closed:closed,
              label: label,
              labelPoint:labelPoint//STORE FORE LATER USE
              // icon: markerIcon
            });

          } else {

            marker = new __google.maps.Marker({
              position: new __google.maps.LatLng(self.markers[i].lat, self.markers[i].lon),
              map: self.map,
              icon: image,
              // labelClass: 'datalayer-link'
              labelClass: 'aa-link'
            });
          }
          self.allMapMarkers.push(marker)
          // get single dealer data for handlebars
          var dealer = [];
          dealer[0] = self.dealerData[i];

          __google.maps.event.addListener(marker, 'click', (function (marker, i) {
            if(self.useFuelStyle) { //BAT25-99
              // console.log(' CLICK ');
              var resultTemplate = $('#fuel-station-info').html();
              var resultHandlebar = Handlebars.hcompile(resultTemplate, {
                  result: dealer
              });
              // BAT-3185 add trigger data layer updates.
              marker.addListener('click', function() {
                // fuelStations.resultItemClick is used to ascertain who is clicking, pin head or result item. pin head fires the DL.CLICK because there is no datalayer-link.
                if (!fuelStations.resultItemClick && !self.ignoreTrigger) {
                  var dataToAdd = {
                    'list_result_count': String(self.allMapMarkers.length),
                    'list_item_index': (i + 1 ).toString(),
                    'link_text':'pin_head'
                  };
                  $.extend(window.dataLayerBAT.data, dataToAdd);
                  window.dataLayerBAT.utils.triggerEvent(document, 'DL.CLICK');
                } else {
                  fuelStations.resultItemClick = false;
                }
                self.ignoreTrigger = false; // this is only used for initial selected items, get passed in selectMarker ( in fuelStations )
                fuelStations.locations.setItemSelected(i);

                // BAT-3185 INFO WINDOW CLOSING TO TRIGGER DL
                __google.maps.event.addListener(infowindow,'closeclick',function(){
                  if (self.InfoWindowIndex === i) {
                    var dataToAdd = {
                      'link_text': 'CLOSE_INFO_WINDOW',
                      'list_item_index': (i + 1 ).toString()
                    };
                    $.extend(window.dataLayerBAT.data, dataToAdd);
                    window.dataLayerBAT.utils.triggerEvent(document, 'DL.CLICK');
                  }
                });
              });

            } else {
              var resultTemplate = $('#template-map-dealer-info').html();
              var resultHandlebar = Handlebars.hcompile(resultTemplate, {
                result: dealer
              });
            }

            return function () {
              var $infoWindowResult;
              infowindow.setContent(resultHandlebar);
              if (!fuelStations) { // BAT-3187. fuelStation is created in mirai-fuel-stations.js, if it doesn't exist, create obj to prevent errors.
                var fuelStations = {};
              }
              self.InfoWindowIndex = i;
              infowindow.open(self.map, marker);
              // BAT-2815 put this marker in global namespace so it can be opened again from outside of this click event
              window.bat.batMapMarker = marker;

              if (fuelStations.resultItemClick) {
                fuelStations.resultItemClick = false; // RESET THE VALUE.
              }
              /*-----------------------------------------------------------------------------------------------------------------
              DL-32: Upon further investigation, the wrong selector is in use on the live site
              (#map-canvas instead of #map-canvas-dealer-search).
              Also, the pre-DL-32 Maps.js contained uncommented window.bat.omni.fire's (still on live site as well)
              see commit: https://repo.digiscloud.com/buyatoyota/BAT_ui/commit/914149f07443372adaba1e0e8fcee131b8bdc1d8
              Presumably these were left in place because planb.js click events on these 'Visit Dealer Website' links are
              NOT being attached (even when switched to use correct #map-canvas-dealer-search selector).
              -------------------------------------------------------------------------------------------------------------------*/
              $infoWindowResult = $(self.mapElement);
              // ensure links to different TDA get a warning message
              $infoWindowResult.find('a[data-tda-code]').on('click', zipTools.warnOnTDAChange);
              $infoWindowResult.find('a.js-maps').on('click', function(){
                var isSafari = $('html').hasClass('safari');
                var isMac = $('html').hasClass('mac');
                var isFF = $('html').hasClass('firefox');
                // if this is our mobile only "view in maps" links, handle differently :(
                var address = '';
                if ($(this).parent().parent().hasClass('visible-sm')) {
                  address = $(this).closest('.js-result-parent').find('a.js-maps').html().split('<span class="overlay-proximity">')[0];
                } else {
                  address = $(this).html().split('<span class="overlay-proximity">')[0];
                }
                address = address.replace(',', '');// example: "1605 VFW ParkwayBoston, MA 02132"
                var urlfa = address.replace(/ /g, '+');
                var mapurl = 'https://maps.google.com/?daddr=' + urlfa;
                // if this is safari or Mac Firefox, let's use apple maps. (Chrome on mac does not handle maps.apple links nicely)
                if(isSafari || (isMac && isFF)) {
                  mapurl = 'https://maps.apple.com/?daddr=' + urlfa;
                }
                // console.log('MAP URL from new FAD page: ', mapurl);
                $(this).attr('href', mapurl);
              });
            };
          })(marker, i));

          /*
            * The google.maps.event.addListener() event waits for
            * the creation of the infowindow HTML structure 'domready'
            * and before the opening of the infowindow defined styles
            * are applied.
            */
          __google.maps.event.addListener(infowindow, 'domready', function() {
            // adjust our layout a bit for ES:
            var $overlayPhoneHours = $('.overlay-phone-hours');
            $overlayPhoneHours.children('.details-tidbit').children('.tidbit-wrap').removeAttr('style');
            $overlayPhoneHours.children('.details-tidbit').children('.tidbit-even-more').removeAttr('style');
            $overlayPhoneHours.children('.details-tidbit').removeAttr('style');

            if (SU.getLangFromUrl() === 'es' && !$('.map-is-collapsed').hasClass('map-is-expanded') && !$('#result-map-wrap-mobile').is(':visible')) {
              $overlayPhoneHours.children('.details-tidbit').children('.tidbit-wrap').css('width', '46%');
              $overlayPhoneHours.children('.details-tidbit').children('.tidbit-even-more').css('width', '54%');

            } else if (SU.getLangFromUrl() === 'es' && $('.map-is-collapsed').hasClass('map-is-expanded') && !$('#result-map-wrap-mobile').is(':visible')){
              $overlayPhoneHours.children('.details-tidbit:first-child').css('width', '46%');
              $overlayPhoneHours.children('.details-tidbit:last-child').css('width', '54%');

            } else if (SU.getLangFromUrl() === 'es' && $('#result-map-wrap-mobile').is(':visible')){
              $overlayPhoneHours.children('.details-tidbit:first-child').css('width', '46%');
              $overlayPhoneHours.children('.details-tidbit:last-child').css('width', '54%');
            }
              // Reference to the DIV which receives the contents of the infowindow using jQuery
            var iwOuter = $('.gm-style-iw');
              /* The DIV we want to change is above the .gm-style-iw DIV.
              * So, we use jQuery and create a iwBackground variable,
              * and took advantage of the existing reference to .gm-style-iw for the previous DIV with .prev().
              */
            var iwBackground = iwOuter.prev().remove();
              // width and height of the thing
              // iwOuter.parent().attr('style', function(i,s){ return s + 'width: 290px !important; height: 100% !important;'});
              // iwOuter.parent().parent().css({left: '18px', height: '90%', top: '10px'});
              // iwOuter.parent().parent().attr('style', function(i,s){ return s + 'left: 18px; height: 90% !important; top: 10px !important;'});

                // Arrow shadow. Moves the shadow
            iwBackground.css('width', '290px'); // parent of arrows, allows us to center arrow

            iwBackground.children(':nth-child(1)').addClass('hidden-sm').attr('style', function(i,s){ return s + 'left: 50% !important; margin-left: -10px'});
            // White arrow containers
            iwBackground.children(':nth-child(3)').addClass('hidden-sm').attr('style', function(i,s){ return s + 'left: 50% !important; margin-left: -10px'});

            // Changes the desired color for the tail outline.
            // The outline of the tail is composed of two descendants of div which contains the tail.
            // The .find('div').children() method refers to all the div which are direct descendants of the previous div.
            iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(178, 178, 178, 0.6) 0px 1px 6px', 'z-index' : '1'});

                // Remove the background shadow DIV
                iwBackground.children(':nth-child(2)').css({'display' : 'none'});
                // Remove the white background DIV
                iwBackground.children(':nth-child(4)').css({'display' : 'none'});

            // It is this div that groups the close button elements.
            var iwCloseBtn = iwOuter.next();

            // Apply the desired effect to the close button
            // iwCloseBtn.css({
            // 	top: 25,
            // 	width: 15,
            // 	opacity: 1
            // });
            // iwCloseBtn.removeAttr('style');

            if(!self.useFuelStyle) {
              iwCloseBtn.removeAttr('style').html('<span class="icon icon-close-modal"></span>').css({top: 24, width: 21, height:21, position: 'absolute', left: 260, padding: 4, background: 'none', borderRadius: 5, webkitBoxShadow: 'none'})
              // actual click img needed to close infowindow
              iwCloseBtn.next().removeAttr('style').css({top: 24, width: 15, position: 'absolute', left: 270});
            }
            if(self.useFuelStyle) {
              // console.log('  ::: iwOuter width', iwOuter.width());
              //bat3187
              iwCloseBtn.removeAttr('style').html('<span class="icon icon-close-modal"></span>').css({top: 24, width: 15, position: 'absolute', left: '90%'});
              // iwCloseBtn.removeAttr('style').html('<span class="icon icon-close-modal"></span>').css({top: 24, width: 15, position: 'absolute', left: 264})
              // // actual click img needed to close infowindow
              // iwCloseBtn.next().removeAttr('style').css({top: 24, width: 15, position: 'absolute', left: 264}); //BAT-2187: not using this.
            }

            // The API automatically applies 0.7 opacity to the button after the mouseout event.
            // This function reverses this event to the desired value.
          });
      }
    }, // END initMultimarker

    initDirections: function () {
      var self = this;
      if (self.mapElement) {
        self.destCoords = {
          'lat': self.mapElement.getAttribute('data-lat'),
          'lng': self.mapElement.getAttribute('data-lng')
        };
        var latitudeForDealer = self.mapElement.getAttribute('data-lat');
        var longitudeForDealer = self.mapElement.getAttribute('data-lng');
        var mapCenter = new __google.maps.LatLng(latitudeForDealer, longitudeForDealer);
        self.mapOptions.center = mapCenter;
        self.map = new __google.maps.Map(self.mapElement, self.mapOptions);

        var marker = new __google.maps.Marker({
          position: mapCenter,
          map: self.map,
          animation: __google.maps.Animation.DROP,
          icon: '/assets/img/maps/marker.png'
        });

        __google.maps.event.trigger(self.map, 'resize');

        setTimeout(function () {
          resizeMapTimer();
        }, 1000);
      }

      $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function(e) {
        var currentTab = $(e.currentTarget).attr('href');
        if (currentTab === '#map-info') {
          setTimeout(function () {
            resizeMapTimer();
          }, 1000);
        }
      });

      function resizeMapTimer() {
        $('#map-canvas').css('width', '100%');
        __google.maps.event.trigger(self.map, 'resize');
        self.map.setCenter(mapCenter);
      }

      self.$form.on('submit', function () {
        var userAddress = $('#origin_address').val();
        self.getOriginCoords(userAddress);
      });

      $('button').on('click', function () {
        $(this).submit();
      });
    },

    getOriginCoords: function (address) {
      var originLocation,
        self = this;
      var geocoder = new __google.maps.Geocoder();

      if (geocoder) {
        geocoder.geocode({
          'address': address
        }, function (results, status) {
          if (status == __google.maps.GeocoderStatus.OK) {

            coordObj = {
              'lat': results[0].geometry.location.lat(),
              'lng': results[0].geometry.location.lng()
            };

            self.getDirections(coordObj);
          } else {
            if (SU.getLangFromUrl() === 'es') {
                alert('No ha podido encontrar su direcciÃ³n.');
            } else {
                alert('Could not find your address.');
            }

            return false;
          }
        });
      }

      return originLocation;
    },

    getDirections: function (originCoords) {
        var self = this;
        self.originCoords = originCoords; //make the Origin Coords accessible
        if (self.directionsDisplay) {
            self.directionsDisplay.setDirections({
                routes: []
            });
        }
        self.directionsService = new __google.maps.DirectionsService();
        self.directionsDisplay = new __google.maps.DirectionsRenderer();
        self.directionsDisplay.setMap(self.map);
        self.directionsDisplay.setPanel(document.getElementById("directionsPanel"));
        self.calcRoute();
    },

    calcRoute: function () {
        var self = this,
            start = new __google.maps.LatLng(self.originCoords.lat, self.originCoords.lng),
            end = new __google.maps.LatLng(self.destCoords.lat, self.destCoords.lng),
            request = {
                origin: start,
                destination: end,
                travelMode: __google.maps.TravelMode.DRIVING
            };

        self.directionsService.route(request, function (response, status) {
            if (status == __google.maps.DirectionsStatus.OK) {
                self.directionsDisplay.setDirections(response);
            } else {
                alert("problem getting directions: " + status)
            }
        });

        __google.maps.event.addListener(self.directionsDisplay, 'directions_changed', function () {
            $('.m-direction-panel').show();
        });

    }
  };

  // needs to return a promise obj.
  // on its resolve, return Maps.
  return function buildMap() {
    return googleMaps()
      .then( function (google) {
        __google = google;
        return Maps;
      })
      .catch(function (err) { console.warn('err in maps: ', err); });
  }

});

